import { SUPPORT_EMAIL } from '../emails';
import { VerificationRejectReason } from './verification';

export const OPERATOR_MIN_WITHDRAW_CENTS = 50_00;
export const OPERATOR_MIN_WITHDRAW_CENTS_OPTIONS = [50_00, 100_00, 200_00, 500_00, 1000_00];

export const SAN_LENGTH_MIN = 9;
export const SAN_LENGTH_MAX = 10;
export const SAN_REGEXP = /^[0-9]+$/;

export const IBAN_LENGTH_MAX = 34;
export const IBAN_REGEX = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;

export const SWIFT_LENGTH_OPTIONS = [8, 11];
export const SWIFT_REGEX = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export const BITCOIN_LENGTH_MIN = 26;
export const BITCOIN_LENGTH_MAX = 42;

export const USDT_LENGTH = 34;

/* eslint-disable max-len */
export const REJECT_REASON_TEXT = (reason: VerificationRejectReason | string | undefined | null): string | undefined => {
    if (!reason) {
        return;
    }

    return {
        [VerificationRejectReason.CustomReason]: '',
        [VerificationRejectReason.Underage]: 'Underage',
        [VerificationRejectReason.VerificationFailed]: 'Unfortunately, we were unable to verify your personality with the provided documents.',
        [VerificationRejectReason.RequestedDocumentsMissing]: 'Unfortunately, you didn’t provide the requested documents.',
        [VerificationRejectReason.UnreadableBlurryImages]: 'There is a problem with your documents or images. Please send us images/documents with all details clearly visible and readable and your selfie holding ID.',
        [VerificationRejectReason.EditedDocumentsPhotos]: `We do not accept edited documents/photos, we are unable to verify your personality for a moment. Send the required documents to <a class="link" href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>.`,
        [VerificationRejectReason.NoLatinCharacters]: 'Unfortunately, we were unable to verify your identity with the provided documents. Please provide any official ID that contains Latin characters.',
        [VerificationRejectReason.UserRequest]: 'It seems you have requested re-verification. Please complete verification or contact support if you haven\'t requested it.',
    }[reason];
};
